import { useEffect } from "react";
import { useAppDispatch } from "@/store/hooks";
import { setPageTitle } from "@/store/slices/globalSlice";

export const usePageTitle = (title: string | null) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageTitle(title));

    return () => {
      dispatch(setPageTitle(null));
    };
  }, [dispatch, title]);
};
